const baseAPIUrl = process.env.REACT_APP_API_URL;

if (!baseAPIUrl) {
  throw new Error('REACT_APP_API_URL is not set in environment variables');
}

export const config = {
  baseAPIUrl,
  endpoints: {
    policies: '/compliance/policies',
    controls: '/compliance/controls',
    evidence: '/compliance/evidence',
    get_cypher_query: '/Get_Cypher_Query',
    chatbot: '/api/chatbot'
  },
  auth0_audience: process.env.REACT_APP_API_AUDIENCE
};
